<template>
  <div id="register" class="register" :class="`register--${showLogoNameOnItsOwn ? 'show-logo-name' : ''}`">
    <div v-if="verificationEmailSent">
      <p>Verification email has been sent to {{ email }}</p>
      <p>Please check your email and click on the link provided.</p>
      <p>Already clicked on the link in the email? <router-link :to="{name: 'login'}">You can now login</router-link></p>
    </div>
    <form class="form" v-else @submit.prevent="register">
      <div class="form-row">
        <label for="email">Email</label>
        <input type="email" id="email" v-model="email" autocomplete="email" />
      </div>
      <div class="form-row">
        <label for="password">Password</label>
        <input type="password" id="password" v-model="password" autocomplete="new-password" />
      </div>
      <p v-if="firebaseErrorMessage" class="error-msg">
        {{ firebaseErrorMessage }}
      </p>
      <button class="register-btn" type="submit">Register</button>
    </form>
    <p class="login">Have an account already? <router-link :to="{name: 'login'}">Login</router-link></p>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import logUserActivity from './../helpers/logUserActivity';
import createUserRecord from './../helpers/createUserRecord';
import {REGISTERED} from './../constants/activityLogs';
import {NOTIFICATION_SETTINGS} from './../constants/globalConstants';

export default {
  name: 'register',
  title: 'Register',
  components: {},
  props: {
    showLogoNameOnItsOwn: Boolean,
  },
  data: function() {
    return {
      email: '',
      password: '',
      verificationEmailSent: false,
      firebaseErrorMessage: '',
      uid: '',
    };
  },
  computed: {},
  methods: {
    register: function() {
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email.trim(), this.password.trim())
        .then(
          userData => {
            userData.user.sendEmailVerification().then(
              () => {
                this.uid = userData.user.uid;
                this.verificationEmailSent = true;
                this.password = '';
                createUserRecord(userData.user.email, userData.user.uid);
              },
              err => {
                this.firebaseErrorMessage = err.message;
                this.$snotify.error('Error sending verification email', '', NOTIFICATION_SETTINGS);
              }
            );
          },
          err => {
            this.firebaseErrorMessage = err.message;
            this.$snotify.error('Error creating account', '', NOTIFICATION_SETTINGS);
          }
        )
        .catch(err => {
          this.$snotify.error('Error creating account', '', NOTIFICATION_SETTINGS);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.register {
  padding-top: 2rem;

  &--show-logo-name {
    padding-top: 8rem;
  }
}

.logo {
  width: 21rem;
  margin: 0 auto 1rem auto;
}

.form {
  background-color: var(--text-color-alpha-10);
  border-radius: var(--border-radius);
  margin: 0 auto 7rem auto;
  max-width: 47rem;
  padding: 3rem;
}

.register-btn {
  margin-top: 3rem;
  min-width: 10rem;
}

.login {
  font-size: 1.4rem;
  max-width: none;
  text-align: center;
}

.error-msg {
  margin: 3rem 0 0 0;
}
</style>
